<style
  lang="less"
  scoped>
  #top-bar {
    width: 100%;
    position: relative;
    z-index: 30;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  #header-user-block {
    ul {
      display: inline-block;
      float: right;
      margin-left: 30px;
      li {
        float: left;
        border-right: 1px solid #333;
        a {
          cursor: pointer;
          padding: 0 8px;
          height: 20px;
          color: #808080;
          &:hover {
            color: #0077db;
          }
        }
      }
      li:nth-of-type(3){
        border-right:none;
      }
    }
  }

  #header-user-block ul :last-child a {
    border-right: none;
  }

  .login_hl span{
    font-size:18px;
    color: #848484;
    border-left:2px solid #b0b0b0;
    height:29px;
    line-height:29px;
    padding-left:20px;
    margin-top:20px;
    letter-spacing: 1px;
  }
  .login_hl{
    display: flex;
    width:267px;
    justify-content:space-between;
  }
</style>

<template>
  <div id="top-bar">
    <div style="border-bottom: 1px solid #eee;height: 25px;padding-top: 4px;">
    <div class="container flex">
      <div>
        <img alt="定位icon" src="../assets/icon_location.png" style="vertical-align: top;">
        <span>{{ getRegion.name }}</span>
      </div>
      <div id="header-user-block">
        <ul v-if="isLogin">
          <li>
            <router-link to="/cart">购物车</router-link>
          </li>
          <li>
            <router-link to="/order">订单</router-link>
          </li>
          <li>
            <router-link to="/person">个人中心</router-link>
          </li>
        </ul>
        <ul v-if="!isLogin">
          <li>
            <router-link :to="{ path: '/register', query: {state: '1'} }">注册</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/login', query: {state: '1'} }">登录</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/login', query: {state: '2'} }">短信登录</router-link>
          </li>
        </ul>
      </div>
    </div>
    </div>
    <div class="container">
      <div class="login_hl">

        <router-link
          :to="{ path: '/'}">
          <img style="height: 44px; margin-top: 10px;cursor: pointer"
               src="//official.cdn.qiyewan.com/logo.png" alt="企业湾logo" title="企业湾">
        </router-link>
        <span>公司信息</span>
      </div>
    </div>
  </div>

</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    data () {
      return {}
    },
    computed: {
      ...mapGetters({
        isLogin: 'isLogin',
        getRegion: 'getRegion',
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// TopBarTiny.vue?2ef0c330